/**
 * A function to create a log object for the 'pageview' event (evid: 401)
 *
 * Event description: Generic event for each pageview
 *
 * @param {pageviewParams} params - The parameters for this event
 * @property {string} sessionId - session id
 * @property {string} pageName - category / website_urls / choose_your_media etc
 * @property {string} type - business / personal / null
 * @return {LogObject<pageviewParams>} LogObject<pageviewParams>
 */
export function pageview(params) {
    return { evid: 401, src: 84, endpoint: 'vmaf', params: params };
}
/**
 * A function to create a log object for the 'buttonClick' event (evid: 402)
 *
 * Event description: Generic event for buttons clicks
 *
 * @param {buttonClickParams} params - The parameters for this event
 * @property {string} sessionId - session id
 * @property {string} buttonName - lets_go / next / back / cancel etc
 * @property {string} pageName - category / website_urls / choose_your_media etc
 * @property {string} type - business / personal / null
 * @property {string} jsonData - button related info
 * @return {LogObject<buttonClickParams>} LogObject<buttonClickParams>
 */
export function buttonClick(params) {
    return { evid: 402, src: 84, endpoint: 'vmaf', params: params };
}
/**
 * A function to create a log object for the 'uploadStart' event (evid: 403)
 *
 * Event description: Media upload started
 *
 * @param {uploadStartParams} params - The parameters for this event
 * @property {string} sessionId - session id
 * @property {string} correlationId - correlation_id
 * @property {string} type - business / personal / null
 * @return {LogObject<uploadStartParams>} LogObject<uploadStartParams>
 */
export function uploadStart(params) {
    return { evid: 403, src: 84, endpoint: 'vmaf', params: params };
}
/**
 * A function to create a log object for the 'uploadFinish' event (evid: 404)
 *
 * Event description: Media upload finished
 *
 * @param {uploadFinishParams} params - The parameters for this event
 * @property {string} mediaType - image / video
 * @property {boolean} success - true / false
 * @property {string} errorReason - error
 * @property {string} sessionId - session id
 * @property {string} correlationId - correlation_id
 * @property {string} type - business / personal / null
 * @return {LogObject<uploadFinishParams>} LogObject<uploadFinishParams>
 */
export function uploadFinish(params) {
    return { evid: 404, src: 84, endpoint: 'vmaf', params: params };
}
/**
 * A function to create a log object for the 'videoCreateStart' event (evid: 405)
 *
 * Event description: Video creation started
 *
 * @param {videoCreateStartParams} params - The parameters for this event
 * @property {string} videoUrl - Magisto video url
 * @property {string} videoCreationSessionId - Magisto session id
 * @property {string} videoId - Magisto video id
 * @property {string} sessionId - session id
 * @property {string} type - business / personal / null
 * @property {string} videoType - preview / final
 * @return {LogObject<videoCreateStartParams>} LogObject<videoCreateStartParams>
 */
export function videoCreateStart(params) {
    return { evid: 405, src: 84, endpoint: 'vmaf', params: params };
}
/**
 * A function to create a log object for the 'videoCreateFinish' event (evid: 406)
 *
 * Event description: Video creation finished
 *
 * @param {videoCreateFinishParams} params - The parameters for this event
 * @property {boolean} success - true / false
 * @property {string} videoUrl - Magisto video url
 * @property {string} videoCreationSessionId - Magisto session id
 * @property {string} videoId - Magisto video id
 * @property {string} errorReason - error
 * @property {string} sessionId - session id
 * @property {string} type - business / personal / null
 * @property {string} videoType - preview / final
 * @property {number} creationTime - ms
 * @return {LogObject<videoCreateFinishParams>} LogObject<videoCreateFinishParams>
 */
export function videoCreateFinish(params) {
    return { evid: 406, src: 84, endpoint: 'vmaf', params: params };
}
/**
 * A function to create a log object for the 'signUpRequested' event (evid: 407)
 *
 * Event description: sign up request
 *
 * @param {signUpRequestedParams} params - The parameters for this event
 * @property {string} sessionId - session id
 * @return {LogObject<signUpRequestedParams>} LogObject<signUpRequestedParams>
 */
export function signUpRequested(params) {
    return { evid: 407, src: 84, endpoint: 'vmaf', params: params };
}
/**
 * A function to create a log object for the 'externalUrlUploadFinish' event (evid: 408)
 *
 * Event description: Media upload from facebook / url finished
 *
 * @param {externalUrlUploadFinishParams} params - The parameters for this event
 * @property {boolean} success - true / false
 * @property {string} sessionId - session id
 * @property {string} type - business / personal / null
 * @property {number} mediaCount - amount of found media
 * @return {LogObject<externalUrlUploadFinishParams>} LogObject<externalUrlUploadFinishParams>
 */
export function externalUrlUploadFinish(params) {
    return { evid: 408, src: 84, endpoint: 'vmaf', params: params };
}
//# sourceMappingURL=index.js.map